import {invoke} from "@hybird/core/bridge/hybirdBridge";
import {BridgeMethod} from "@hybird/core/bridge/core";

export class FlutterRequest extends BridgeMethod {
  constructor() {
    super();
  }
  /**
   * @param params{{
   *             url,
   *             data,
   *             queryParameters,
   *             method,
   *             header,
   *             sendTimeout,
   *             receiveTimeout
   * }}
   * @param on{{onSendProgress,onFinish,onError,onReceiveProgress} }
   *
   * @return {Promise<{
   *   code:int,//返回的code码
   *   data:Object, //当前方法返回的对象信息
   *   event: {onSendProgress,onFinish,onError,onReceiveProgress} //当前调用产生的event
   *   method: {abort}
   * }>}
   */
  async request(params, on) {
    return invoke("request", {
      params: params, on, parseResult: false
    });
  }
}

export const flutterRequest = new FlutterRequest();